import { fetchDisclaimerPlain } from '../../../hooks/useDisclaimer';

// The Allocation Calculator disclaimer is managed in Admin > Disclaimers
// (tool_allocation_calculator) and shared by the app, the print/PDF view and
// the Excel export. "the date shown" refers to the output date carried on the
// document itself (the "Target weights as at" meta line shows the day of output).
export const DISCLAIMER_KEY = 'tool_allocation_calculator';

export function fetchCalculatorDisclaimer() {
  return fetchDisclaimerPlain(DISCLAIMER_KEY);
}
